// extracted by mini-css-extract-plugin
export default {"place":"MiddleTopBar_place__H0vKg","last":"MiddleTopBar_last__xxOvG","homeIcon":"MiddleTopBar_homeIcon__bVcGO"};